export default function AppSection() {
  return (
    <section id="app" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12 bg-background-50 border border-background-200/70 rounded-2xl p-8 md:p-10">
            <div className="flex-1 text-center lg:text-left">
              <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">移动端畅享阅读</h2>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
                古古漫画网完美适配手机与平板浏览器，无需下载安装即可享受极致下拉式阅读体验。打开浏览器输入网址，随时随地追更你喜欢的漫画作品。
              </p>
              <div className="flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
                <a
                  href="#"
                  className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-foreground-950 text-background-50 text-sm font-medium hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer no-underline"
                >
                  <i className="ri-android-line"></i>
                  Android 访问
                </a>
                <a
                  href="#"
                  className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-foreground-950 text-background-50 text-sm font-medium hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer no-underline"
                >
                  <i className="ri-apple-line"></i>
                  iOS 访问
                </a>
              </div>
              <p className="text-xs text-foreground-400 mt-4">
                无需下载APP，浏览器打开即用 · 支持添加到桌面快捷方式
              </p>
            </div>
            <div className="w-48 lg:w-56 shrink-0">
              <div className="aspect-[9/16] rounded-2xl overflow-hidden border-4 border-background-200 shadow-lg">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20smartphone%20mockup%20displaying%20a%20manga%20reading%20app%20interface%20with%20colorful%20manga%20pages%2C%20clean%20modern%20mobile%20UI%20design%2C%20vertical%20scrolling%20manga%20reader%20layout%2C%20bright%20and%20vibrant%20illustration%20style%2C%20simple%20phone%20frame%20on%20clean%20background&width=400&height=710&seq=app-01&orientation=portrait"
                  alt="古古漫画网移动端阅读界面"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}